import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Sgkc011aRequest, SlideadjustmentunitpriceLstInfoDto, SGKC011AService } from 'sg-api';


/**
 * スライド調整単価一覧取得API使用サービス
 * @export
 * @class UsedSgkc011aService
 */

@Injectable({
    providedIn: 'root'
})
export class UsedSgkc011aService {

    /**スライド調整単価一覧取得結果のSubject */
    private _tankatableResult$: Subject<Array<SlideadjustmentunitpriceLstInfoDto>> = new Subject<Array<SlideadjustmentunitpriceLstInfoDto>>();

    /**
   * コンストラクタ
   * @param {SGKC011AService} sGKC011AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc011aService
   */
    constructor(
        private sGKC011AService: SGKC011AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     * スライド調整単価一覧取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc011aService
     */
    get slideTankaInfoChanges() {
        return this._tankatableResult$.asObservable();
    }

    /**
       * スライド調整単価一覧取得API呼び出し
       * @param {Sgkc011aRequest} value
       * @return {Observable<Array<SlideadjustmentunitpriceLstInfoDto>>}
       * @memberof UsedSgkc011aService
       */
    searchSlideTankatable(value: Sgkc011aRequest): Observable<Array<SlideadjustmentunitpriceLstInfoDto>> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC011AService.kC10RSGKC011APost(<Sgkc011aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableResult$.next(response.body.slideadjustmentunitpriceLstInformationlist);
                    return response.body.slideadjustmentunitpriceLstInformationlist;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC011A');
                    return throwError(err.message);
                })
            );
    }
}

